import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import { CONFIG } from '../config/config';
import { useUserStore } from '../stores/UserStore';

export const encrypt = (value: string, key: string = '') => {
  try {
    const finalKey = CONFIG.BOT_UUID + (key || useUserStore.getState().UBUUID);
    return AES.encrypt(value, finalKey).toString();
  } catch (e) {
    return '';
  }
};

export const decrypt = (value: string, key: string = '') => {
  try {
    const finalKey = CONFIG.BOT_UUID + (key || useUserStore.getState().UBUUID);
    return AES.decrypt(value, finalKey).toString(Utf8);
  } catch (e) {
    return '';
  }
};
